// extracted by css-extract-rspack-plugin
export default {"da-protect-icon":"yhT2k_","daProtectIcon":"yhT2k_"};